<template>
  <v-row justify="center">
    <v-dialog v-model="isWindowDisplayed" max-width="800px" max-height="600">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" large title="Ajouter affectation">
          {{ iconAdd }}
        </v-icon>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Affectation d'une ressource à un projet</span>
        </v-card-title>
        <template
          v-if="new Date().getTime() < new Date(project.endDate).getTime()"
          ><v-card-text>
            <v-container>
              <v-row>
                <v-row class="mt-2">
                  <v-col class="d-flex mx-auto justify-center" cols="5">
                    <v-select
                      :items="[project]"
                      v-model="projectP"
                      item-text="name"
                      item-value="id"
                      name="project"
                      label="Selection du projet"
                      color="#51bdcb"
                      item-color="dark"
                      disabled
                      class="mt-auto"
                    >
                    </v-select>
                  </v-col>
                  <v-col class="d-flex mx-auto justify-center" cols="7">
                    <v-autocomplete
                      :items="orderedGetAllResources"
                      v-model="resource"
                      item-text="name"
                      item-value="id"
                      name="resource"
                      label="Selection de la ressource"
                      color="#51bdcb"
                      item-color="dark"
                      multiple
                      chips
                      deletable-chips
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-col class="d-flex mt-3" cols="12">
                  <v-slider
                    label="Pourcentage par semaine"
                    thumb-label="always"
                    min="0"
                    max="100"
                    step="5"
                    color="#51bdcb"
                    track-color="grey"
                    v-model="percentage"
                  ></v-slider>
                </v-col>
                <v-col>
                  <template>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <vc-date-picker
                          show-iso-weeknumbers="left-outside"
                          v-model="dates"
                          :available-dates="{
                            start: new Date(project.startDate),
                            end: 0,
                          }"
                          mode="date"
                          is-range
                          color="gray"
                          class="mx-7"
                        >
                        </vc-date-picker>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="dateRangeStart"
                          label="Premier jour"
                          prepend-icon="mdi-calendar"
                          readonly
                          color="#51bdcb"
                        ></v-text-field>
                        <v-text-field
                          v-model="dateRangeEnd"
                          label="Dernier jour"
                          prepend-icon="mdi-calendar"
                          readonly
                          color="#51bdcb"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
                <template v-if="isErrorMessageDisplayed">
                  <PopUpError
                /></template>
              </v-row>
            </v-container>
          </v-card-text>
        </template>
        <template v-else>
          <p class="text-center text-h6 px-auto mt-10">
            Ce projet est terminé depuis le
            {{ new Date(project.endDate).toLocaleDateString() }}.
          </p>
          <p class="text-center text-h6 px-auto pb-5">
            Ajouter des affectations n'est plus possible !
          </p>
        </template>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#51bdcb" text @click="closeWindow"> Annuler </v-btn>
          <v-btn
            :disabled="resource.length == 0"
            color="#51bdcb"
            text
            @click="addAssignment"
          >
            Affecter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ADD_ASSIGNMENT } from '../graphql/GraphQLMutations';
import { GET_ALL_PROJECTS, GET_ALL_RESOURCES } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

const _ = require('lodash');

export default {
  name: 'ModalAssignment',

  apollo: {
    getAllResources: {
      query: GET_ALL_RESOURCES,
    },
  },

  components: {
    PopUpError,
  },

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isWindowDisplayed: false,
    resource: [],
    projectP: {},
    iconAdd: 'mdi-account-multiple-plus',
    isErrorMessageDisplayed: false,
    percentage: 50,
    dates: {
      start: new Date(),
      end: new Date(),
    },
    dialog: false,
  }),

  mounted() {
    if (this.project) {
      this.projectP = this.project;
    }
  },

  computed: {
    orderedGetAllResources() {
      return _.orderBy(this.getAllResources, 'name');
    },
    dateRangeStart() {
      const dateStart = this.dates.start.toISOString().slice(0, 10);
      return dateStart;
    },
    dateRangeEnd() {
      const dateEnd = this.dates.end.toISOString().slice(0, 10);
      return dateEnd;
    },
  },

  methods: {
    closeWindow() {
      // canceled errors and empty field
      this.isErrorMessageDisplayed = false;
      this.isWindowDisplayed = false;
      this.percentage = 50;
      this.resource = [];
      this.dates.start = new Date();
      this.dates.end = new Date();
    },
    addAssignment() {
      // reset error
      this.isErrorMessageDisplayed = false;

      if (this.resource) {
        for (let i = 0; i < this.resource.length; i += 1) {
          const ass = {
            projectID: this.project.id,
            resourceID: this.resource[i],
            startDate: this.dateRangeStart,
            endDate: this.dateRangeEnd,
            percentage: parseInt(this.percentage, 10),
            validated: false,
          };
          if (ass.projectID && ass.resourceID && ass.percentage > 0) {
            this.$apollo
              .mutate({
                mutation: ADD_ASSIGNMENT,
                variables: {
                  input: ass,
                },
                update: (cache, { data: { addAssignment } }) => {
                  // Update projects cache data
                  const cachedProjects = cache.readQuery({
                    query: GET_ALL_PROJECTS,
                  });
                  const projectIndex = _.findIndex(
                    cachedProjects.getAllProjects,
                    {
                      id: addAssignment.project.id,
                    }
                  );
                  if (projectIndex >= 0) {
                    cachedProjects.getAllProjects[
                      projectIndex
                    ].assignments.push(addAssignment);
                    cache.writeQuery({
                      query: GET_ALL_PROJECTS,
                      data: cachedProjects,
                    });
                  }

                  const cachedResources = cache.readQuery({
                    query: GET_ALL_RESOURCES,
                  });
                  const resourceIndex = _.findIndex(
                    cachedResources.getAllResources,
                    {
                      id: addAssignment.resource.id,
                    }
                  );
                  if (resourceIndex >= 0) {
                    cachedResources.getAllResources[
                      resourceIndex
                    ].assignments.push(addAssignment);
                    cache.writeQuery({
                      query: GET_ALL_RESOURCES,
                      data: cachedResources,
                    });
                  }
                },
              })
              .then(() => {
                // Result
                this.message = '';
                this.percentage = 50;
                this.resource = [];
                this.dates.start = new Date();
                this.dates.end = new Date();
                this.isWindowDisplayed = false;
                this.isErrorMessageDisplayed = false;
              })
              .catch(() => {
                this.isErrorMessageDisplayed = true;
              });
          } else {
            this.isErrorMessageDisplayed = true;
          }
        }
      }
    },
  },
};
</script>
